import React from 'react'
import Img, { FluidObject } from 'gatsby-image'

export type ImageProps = {
  alt?: string
  classname?: string
  fluid?: FluidObject
  height?: number
  id?: string
  src?: string
  width?: number
}

export const Image = ({
  alt,
  classname,
  fluid,
  height,
  id,
  src,
  width
}: ImageProps) => {
  if (fluid) {
    return <Img fluid={fluid} className={classname} />
  }

  return (
    <img
      id={id}
      src={src}
      alt={alt}
      className={classname}
      width={width}
      height={height}
    />
  )
}
export default Image
